module.exports = __webpack_public_path__ + "img/14-01_Being Trustworthy.5b3cfe74.svg";